var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 245,
    viewBox: "0 0 1035 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1413.49 -59.4747C1320.37 -44.2765 1310.28 -105.948 1217.16 -90.7498C1124.03 -75.5516 1134.11 -13.8823 1040.97 1.31355C947.841 16.5094 937.765 -45.1598 844.631 -29.9639C751.497 -14.768 761.583 46.9035 668.449 62.0994C575.325 77.2976 565.037 15.5145 471.913 30.7127C378.789 45.9109 388.865 107.58 295.731 122.776C202.596 137.972 192.521 76.3027 99.387 91.4986C6.25285 106.694 16.3386 168.366 -76.7956 183.562",
    stroke: "#12CDA7",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1427.23 48.6924C1334.1 63.8907 1324.02 2.21906 1230.89 17.4173C1137.77 32.6155 1147.84 94.2848 1054.71 109.481C961.575 124.677 951.5 63.0073 858.366 78.2032C765.232 93.3991 775.318 155.071 682.183 170.267C589.06 185.465 578.772 123.682 485.648 138.88C392.524 154.078 402.6 215.747 309.465 230.943C216.331 246.139 206.256 184.47 113.122 199.666C19.9877 214.862 30.0734 276.533 -63.0607 291.729",
    stroke: "#12CDA7",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg100);
export default __webpack_public_path__ + "static/media/bg_100.504ed59b242409f4d33515d4bc6b8fca.svg";
export { ForwardRef as ReactComponent };